import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("KRİTİK HATA: Frontend Supabase URL veya Anon Key bilgisi .env dosyasında bulunamadı.");
}

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "");